<template>
  <div class="requests-info">
    <div v-if="originalFiles.length > 0">
      <div v-for="(file, index) in originalFiles" :key="index">
        <div class="section-title" style="margin-bottom:20px;">Client Original File #{{index+1}}: <span class="view-original-file" @click="showFile(file)">{{file.filename}}</span></div>
        <div class="field file-padded-bottom-border" style="padding-bottom: 1.5rem;">
          <div class="control">
              <div class="columns">
                  <div class="column is-3">
                      <file-uploader :vuexStore="fileUploadStore" :vuexUploadAction="fileUploadAction" :buttonName="buttonName" :vuexSelectAction="fileSelectAction" :setDescription="setDescription" :attachTo="file"></file-uploader>
                  </div>
                  <div class="column is-9 pull-left">
                      <p>Upload completed translation for {{file.filename}} here.</p>
                  </div>
              </div>
          </div>
        </div>
        <div class="details gray-bg">
          <div class="field file-padded-bottom-border file-header">
            <div class="control">
              <div class="columns">
                <div class="column is-2">
                  <div class="formfield">Translation</div>
                </div>
                <div class="column is-5">
                  <div class="formfield">Filename</div>
                </div>
                <div class="column is-3">
                  <div class="formfield">Upload Date</div>
                </div>
                <div class="column is-2">
                  <div class="formfield">Status</div>
                </div>
              </div>
            </div>
          </div>
          <TranslationFiles :file="file" @show-file="showFile"/>
        </div>
      </div>
    </div>

    <div v-else>
      Original documents not found.
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import TranslationFiles from '@/components/Home/Views/TranslationFiles';
export default {
  components: {
    TranslationFiles
  },
  data() {
    return {
      fileUploadStore: "translationFile",
      fileSelectAction: "canUploadFile",
      fileUploadAction: "uploadFile",
      setDescription: false,
      buttonName: "+ Upload",
    };
  },

  computed: {
    ...mapState("requests", {
      originalFiles: (state) => state.originalFiles,
      //completedFiles: (state) => state.completedFiles,
    }),

    ...mapGetters("requests", {
      jobType: "getJobType",
      //originalFiles: "getoriginalFiles"
    }),
  },

  methods: {
    showFile(file){
        VueStore.dispatch('translationFile/setVariable', {key: 'selectedFile', value: file});
        VueStore.dispatch('notify/setShowMessage', {key: 'viewUploadedFiles', bool: true});
    },
    setDelete(id) {
      // show modal to confirm deletion
      VueStore.dispatch("notify/setShowMessage", {
        key: "showDeleteFileConfirm",
        bool: true,
      });

      // setup vuex to so we can pull the selected id to delete
      // after user confirm
      VueStore.dispatch("requestFiles/pushToFileDelete", id);
    },
  },

  mounted() {},

  created() {},
};
</script>

<style scoped>
</style>
